export const PAGINATION = {
    PERPAGE: 15,
    CURRENT_PAGE: 1,
    LAST_PAGE: 0,
    FROM: 0,
    TO: 0,
    TOTAL: 0,
};

export const ACTION_MODE = {
    CREATE: 'create',
    UPDATE: 'update',
};

export const ACCESS_FILE_IMAGE_TYPE = ['jpeg', 'JPEG', 'png', 'PNG', 'jpg', 'JPG'];

export const UPLOAD_FILE_LIMIT = 20;

export const PERMISSIONS_DATA = {
    ADMIN: 1,
    MANAGER: 2,
};

export const FEDEX_SERVICE = {
    STANDARD: {
        name: 'Standard',
        value: 'STANDARD'
    },
    EXPEDITED: {
        name: 'Expedited',
        value: 'EXPEDITED'
    },
    EXPRESS: {
        name: 'Express',
        value: 'EXPRESS'
    }
};

export const FEDEX_2DAY_SERVICE = {
    STANDARD: {
        name: 'Standard',
        value: 'FEDEX_2_DAY'
    },
    EXPEDITED: {
        name: 'Expedited',
        value: 'FEDEX_2_DAY'
    },
    EXPRESS: {
        name: 'Express',
        value: 'EXPRESS_SAVER'
    }
};

export const FEDEX_EXPRESS_FREIGHT = {
    STANDARD: {
        name: 'Standard',
        value: 'FEDEX_2_DAY_FREIGHT'
    },
    EXPEDITED: {
        name: 'Expedited',
        value: 'FEDEX_2_DAY_FREIGHT'
    },
    EXPRESS: {
        name: 'Express',
        value: 'FEDEX_3_DAY_FREIGHT'
    }
};
